export default function () {
	const logos = document.querySelectorAll('.js-logo-show-item');

	logos.forEach((logo) => {
		const parent = logo.closest('.js-logo-show');
		logo.addEventListener('mouseenter', () => {
			parent.classList.add('has-hover');
		});
		logo.addEventListener('mouseleave', () => {
			parent.classList.remove('has-hover');
		});
	});
}
